module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 mt-2"
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex panel p-0 pb-2 border-top-lightest border-left-lightest border-right-lightest justify-content-end"
  }, [_c('button', {
    staticClass: "btn blue",
    on: {
      "click": _vm.createRefundBtn
    }
  }, [_vm._v("Create Refund")])]), _vm._v(" "), _c('div', {
    staticClass: "my-4"
  }, [(_vm.reservation.refunds.length > 0) ? _c('refund-rows', {
    attrs: {
      "refunds": _vm.reservation.refunds
    }
  }) : _c('div', {
    staticClass: "text-center fs-large dark w-100"
  }, [_vm._v("\n            No refunds found\n        ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-898ed670"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit/TabRefunds.vue
// module id = 1675
// module chunks = 0